(function () {
  'use strict';

  angular
    .module('neo.home.adminUsers')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.adminUsers', {
        url: '/admin/users',
        templateUrl: 'home/admin-users/admin-users.tpl.html',
        controller: 'AdminUsersCtrl',
        controllerAs: 'vm',
        resolve: {
          ajuntaments: function (Ajuntaments) {
            return Ajuntaments.query().$promise;
          }
        }
      });
  }
}());
